import React, { useState } from "react";
import { Box, Divider, Typography, Tooltip, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled, useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { UserPermissionConstants } from "../utils/permissions";
import utils from "../utils/utils";
import CommonDateTimePicker from "../common/commonDateTimePicker";

const StyledButton = styled((props) => <Button {...props} />)(({ theme }) => ({
  height: "36px",
  backgroundColor: theme.palette.custom.buttonColor,
  color: theme.palette.custom.buttonTextColor,
  "&:hover": {
    backgroundColor: theme.palette.custom.buttonHoverColor,
    color: theme.palette.custom.buttonHoverTextColor,
    boxShadow: "none",
  },
  width: "min-content",
}));

function HomeGrafanaPage() {
  const theme = useTheme();
  const { t } = useTranslation();
  const permissions = useSelector(({ permissions }) => permissions);
  const [editGrafanaLink, setEditGrafanaLink] = useState(null);
  const handleUpdateGrafanaLink = (newUrl) => {
    const newGrafanaLink = newUrl
      .replaceAll(
        window.env.REACT_APP_GRAFANA_URL,
        window.env.REACT_APP_EDITGRAFANA_URL
      )
      .replaceAll("&kiosk=true", "");

    setEditGrafanaLink(newGrafanaLink);
  };
  function handleAssignEditDashboard() {
    window.open(editGrafanaLink, "_blank").focus();
  }
  return (
    <Box
      sx={{
        p: "12px",
        minHeight: `100%`,
        height: "100%",
      }}
    >
      <Box sx={{ width: "100%", height: { xs: "fit-content", sm: `108px` } }}>
        <Box sx={{ display: { xs: "block", sm: "flex" } }}>
          <Typography
            sx={{
              fontSize: "45px",
              mb: 0,
              color: theme.palette.custom.borderColor,
            }}
            variant="h2"
            gutterBottom
          >
            {t("IoT")}
          </Typography>
          <Typography
            sx={{
              mt: 1,
              color: theme.palette.custom.buttonTextColor,
            }}
            variant="h4"
            gutterBottom
          >
            {t("InternetOfThings")}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "block", sm: "center" },
            width: "100%",
          }}
        >
          <Typography
            sx={{
              fontSize: "2.5rem",
              mb: 0,
              color: theme.palette.custom.buttonTextColor,
            }}
          >
            {t("Dashboard")}
          </Typography>
          {permissions &&
            utils.hasPermission(
              UserPermissionConstants.OPEN_DASHBOARD_LINK_IN_GRAFANA,
              permissions
            ) && (
              <>
                <Tooltip title={t("OpenInGrafana")}>
                  <StyledButton
                    variant="contained"
                    onClick={handleAssignEditDashboard}
                  >
                    {t("EditDashboard")}
                  </StyledButton>
                </Tooltip>
              </>
            )}
        </Box>
      </Box>
      <Divider
        sx={{ my: "10px", backgroundColor: theme.palette.custom.borderColor }}
      />
      <Box
        sx={{
          height: { xs: "100%", sm: `calc(100% - 108px)` },
        }}
      >
        <CommonDateTimePicker
          handleUpdateGrafanaLink={handleUpdateGrafanaLink}
        />
      </Box>
    </Box>
  );
}

export default HomeGrafanaPage;
